/** Escapa caracteres especiais do padrão ILIKE do Postgres. */
export function escapeIlikePattern(raw: string): string {
  return raw.trim().split(",").join(" ").replace(/[%_\\]/g, "\\$&");
}

export function normalizeProductSearchToken(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "");
}
